import { render, staticRenderFns } from "./SingleAppeal.vue?vue&type=template&id=083fc905&"
import script from "./SingleAppeal.vue?vue&type=script&lang=js&"
export * from "./SingleAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports